"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UIStream = void 0;
var logger_utils_1 = require("../utils/logger-utils");
var LogLevel_1 = require("../enums/LogLevel");
var LogType_1 = require("../enums/LogType");
var axios_1 = __importDefault(require("axios"));
var UIStream = (function () {
    function UIStream(config) {
        this.config = config;
        this.logLevels = logger_utils_1.LoggerUtils.transposeKeyValue(LogLevel_1.LevelFromName);
    }
    UIStream.prototype.getStreams = function () {
        var streams = [];
        if (!this.config.silent) {
            var defaultStream = this.createDefaultStream();
            streams.push({
                type: LogType_1.LogType.raw,
                stream: defaultStream
            });
        }
        if (this.config.sendToServer) {
            var sendToSeverStream = this.createSendToServerStream();
            streams.push({
                type: LogType_1.LogType.raw,
                stream: sendToSeverStream
            });
        }
        return streams;
    };
    UIStream.prototype.createDefaultStream = function () {
        var _this = this;
        return {
            write: function (rec) {
                if (!rec) {
                    return;
                }
                var recCopy = Object.assign({}, rec);
                try {
                    _this.transformLogRecord(recCopy);
                    if (_this.shouldPrintFrontEndLog()) {
                        console.log(recCopy);
                    }
                }
                catch (e) {
                    var parsedRec = _this.setCatchMessage(recCopy, e.message);
                    if (_this.shouldPrintFrontEndLog()) {
                        console.log(parsedRec);
                    }
                }
            }
        };
    };
    UIStream.prototype.createSendToServerStream = function () {
        var _this = this;
        return {
            write: function (rec) {
                logger_utils_1.LoggerUtils.deleteFields(rec);
                _this.sendLogToServer(rec);
            }
        };
    };
    UIStream.prototype.transformLogRecord = function (rec) {
        logger_utils_1.LoggerUtils.resolveChildLoggerDefaults(rec);
        logger_utils_1.LoggerUtils.populateMissingRequiredFields(rec, this.config, this.logLevels);
        logger_utils_1.LoggerUtils.resolveCollision(rec);
        logger_utils_1.LoggerUtils.setTimeFields(rec);
        logger_utils_1.LoggerUtils.deleteFields(rec);
    };
    UIStream.prototype.setCatchMessage = function (rec, errorMessage) {
        if (!rec) {
            rec = {};
        }
        rec.level = 'error';
        logger_utils_1.LoggerUtils.reAssignPiiLevel(rec);
        logger_utils_1.LoggerUtils.assignErrorCode(rec);
        logger_utils_1.LoggerUtils.assignErrorMessage(rec, errorMessage);
        return rec;
    };
    UIStream.prototype.sendLogToServer = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.serverURL) {
                            throw new Error('log server url not configured.');
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, axios_1.default.post(this.config.serverURL + '/uiLog', data)];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        err_1 = _a.sent();
                        throw new Error('send log to server err: ' + err_1.message);
                    case 4: return [2];
                }
            });
        });
    };
    UIStream.prototype.shouldPrintFrontEndLog = function () {
        return typeof window === 'object' && typeof document === 'object';
    };
    return UIStream;
}());
exports.UIStream = UIStream;
//# sourceMappingURL=ui-stream.js.map